'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './quickbooks-overview.routes';

export class QuickbooksOverviewComponent {
  constructor(QuickbooksImportService, $stateParams, $window, ContactService, DTOptionsBuilder, $filter,
              $scope, ViewSelection, DTDefaultOptions, DTState) {
    'ngInject';

    this.$scope = $scope;
    this.ViewSelection = ViewSelection;

    this.contactId = $stateParams.contactId;
    this.back = _ => $window.history.back();

    this.count = {all: 0, debit: 0, balanced: 0, credit: 0, unassigned: 0};

    $scope.ViewSelection = ViewSelection;
    $scope.$watch('ViewSelection.selectedCommunity', (newVal, oldVal, scope) => {
      this.selectedCommunity = newVal.name;
      this.selectedCommunityCode = newVal.value;
      this.filterData(this.selectedCommunityCode, this.cat);
    });

    this.chartData = {
      'dist': [],
      'asn': [[],[],[]]
    };
    this.chartLabels = {
      'dist': ["Debit","Balanced","Credit"],
      'asn': []
    };
    this.chartColors = {
      'dist': ['#C70039','#A0A0A0','#2ECC71'],
      'asn':  ['#C70039','#A0A0A0','#2ECC71']
    };

    this.chartSeries = {
      'asn': ["Debit","Balanced","Credit"]
    };

    this.chartOptions = {
      'dist': {
        legend: {
          display: true,
          position: 'bottom'
        },
        title: {
          display: true,
          text: 'Account Balance Distribution'
        },
        animation: false
      },
      'asn': {
        title: {
          display: true,
          text: 'Account Balance Distribution per Association'
        },
        animation: false,
        plugins: {
          stacked100: { enable: true }
        },
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            stacked: true
          }]
        }
      }
    };

    DTDefaultOptions.setLoadingTemplate( "<datatable-loading-placeholder columns='Contact, Account, Community, Import Date, Balance />");

    this.dtOptions = DTOptionsBuilder
      .newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [[0, 'asc'],[1, 'asc']])
      .withOption('stateSave',true)
      .withOption('stateSaveCallback', DTState.save())
      .withOption('stateLoadCallback', DTState.restore())
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      .withOption('buttons',[{
        extend: 'excel',
        title: "Quickbook Balances"
      },{
        extend: 'csv',
        title: "Quickbook Balances"
      },{
        title: "Quickbook Balances",
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'portrait',
        pageSize: 'LETTER'
      },{
        extend: 'print',
        title: "Quickbook Balances"
      }])
      .withOption('fnFooterCallback', function ( row, data, start, end, display ) {
        var api = this.api(), data;

        // Remove the formatting to get integer data for summation
        var intVal = function ( i ) {
          return typeof i === 'string' ?
            i.replace(/[\$,]/g, '')*1 :
            typeof i === 'number' ?
              i : 0;
        };

        var roundCorrectly = function(number){ return Math.round(number * 100)/100 };

        // Total over all pages
        var total = api
          .column( 5 )
          .data()
          .reduce( function (a, b) {
            return intVal(a) + intVal(b);
          }, 0 );

        // Total over this page
        var pageTotal = api
          .column( 5, { page: 'current'} )
          .data()
          .reduce( function (a, b) {
            return intVal(a) + intVal(b);
          }, 0 );

        // Total over this page
        var visibleTotal = api
          .column( 5, { search: 'applied'} )
          .data()
          .reduce( function (a, b) {
            return intVal(a) + intVal(b);
          }, 0 );

        let modifier = "";
        if (visibleTotal > 0) {
          modifier=" class='text-danger' ";
        } else if (visibleTotal < 0) {
          modifier=" class='text-success' ";
        }

        // Update footer
        $( api.column( 5 ).footer() ).html(
          '<nobr><span ' + modifier + '> $ '+ $filter('number')(roundCorrectly(visibleTotal), 2) + '</span></nobr>'
        );
      });


    QuickbooksImportService.queryUnassigned(dataUnassigned => {
      this.dataUnassigned = dataUnassigned;
      this.filterData(ViewSelection.selectedCommunityCode);
    });

    QuickbooksImportService.query(data => {
      this.data = data;
      this.filterData(ViewSelection.selectedCommunityCode);
      this.dataInitComplete = true;

      let asnDistChart = {};

      this.data.forEach(account => {
        let key = account.community.code;
        if (!asnDistChart[key]) {
          asnDistChart[key] = {
            debit: 0,
            balanced: 0,
            credit: 0
          };
        }

        if (account.balance == 0) {
          asnDistChart[key].balanced++;
        } else if (account.balance > 0) {
          asnDistChart[key].debit++;
        } else {
          asnDistChart[key].credit++;
        }
      });

      Object.keys(asnDistChart).forEach(code => {
        this.chartLabels['asn'].push(code);
        this.chartData['asn'][0].push(asnDistChart[code].debit);
        this.chartData['asn'][1].push(asnDistChart[code].balanced);
        this.chartData['asn'][2].push(asnDistChart[code].credit);
      });

    });
  }

  getPrimaryOwner(property) {
    let primary = property.contacts.find(c => c.type == 'primary-owner');
    if (primary)
      return primary.contact;
    else
      return null;
  }

  getPrimaryOwnerId(property) {
    let primary = this.getPrimaryOwner(property);
    if (primary)
      return primary._id;
  }

  roundCorrectly(number) {
    /*
     * var x = 1243.95;
     *     x += -414.65;  --> x = 829.3000000000001 wooot ??
     */
    return Math.round(number * 100)/100;
  }

  filterData(code, cat) {
    if (code) {
      this.filteredData = this.c.filter(ppty => ppty.community && ppty.community.code == code)
    } else {
      this.filteredData = this.data;
    }

    if (this.dataUnassigned && this.dataUnassigned.length) {
      if (code) {
        this.filteredDataUnassigned = this.dataUnassigned.filter(ppty => ppty.community.code == code);
      } else {
        this.filteredDataUnassigned = this.dataUnassigned;
      }
    }

    this.count.all = this.getCount('all');
    this.count.debit = this.getCount('debit');
    this.count.balanced = this.getCount('balanced');
    this.count.credit = this.getCount('credit');

    this.count.unassigned = (this.dataUnassigned && this.dataUnassigned.length) ? this.filteredDataUnassigned.length : 0;

    this.chartData['dist'] = [this.count.debit, this.count.balanced, this.count.credit];

    if (cat && cat !== 'all') {
      switch (cat) {
        case 'credit':
          this.filteredData = this.filteredData.filter(li => li.balance < 0);
          break;
        case 'debit':
          this.filteredData = this.filteredData.filter(li => li.balance > 0);
          break;
        case 'balanced':
          this.filteredData = this.filteredData.filter(li => li.balance == 0);
          break;
      }
    }
  }

  getCount(cat) {
    if (!this.filteredData || !this.filteredData.length)
      return 0;

    return this.filteredData.reduce((acc, obj) => {
      switch (cat) {
        case 'balanced':
          return acc + (obj.balance == 0);
        case 'credit':
          return acc + (obj.balance < 0);
        case 'debit':
          return acc + (obj.balance > 0);
        default:
          return acc + 1;
      }

    }, 0);
  }

  setFilter(cat) {
    this.cat = cat;
    this.filterData(this.selectedCommunityCode, this.cat);
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += " (" + contact.company + ")";
    }

    return composedName || "-";
  }
}

export default angular.module('conduu.quickbooksOverview', [uiRouter])
  .config(routes)
  .component('quickbooksOverview', {
    template: require('./quickbooks-overview.html'),
    controller: QuickbooksOverviewComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/import/quickbooks-overview/quickbooks-overview.component.js